import createDocumentResource from '../shared/createDocumentResource';

// Should match AD model src/scripts/domain/models/system_configuration.js
interface SystemConfiguration {
  id: string; // Ignore just to satisfy resource interface
  fbAppId?: string;
  publicUrl: string;
}

function fetchSuccess(state, action) {
  state.loadingState = 'succeeded';
  state.value = action.payload;
}

const systemConfigurationResource = createDocumentResource<SystemConfiguration>({
  name: 'systemConfiguration',
  endpoint: 'v1/system-configuration',
  reducers: {
    fetchSuccess,
  },
  initialValue: {},
});

export default systemConfigurationResource;
